export class GamePadModel {
    public pos: [number, number] = [0, 0];
    public visible: boolean = true;
    public showCloseButton: boolean = false;
    public showGamePad: boolean = true;

    public constructor() {
    }

    public clear(): void {
        this.pos = [0, 0];
        this. visible = true;
        this.showCloseButton = false;
        this.showGamePad = true;
    }
}
